import clsx from 'clsx'
import CountUp from 'react-countup'
import {useLocation, useNavigate} from 'react-router-dom'
import {ROUTES} from '../../../constants/_routes'
import {KTSVG} from '../../../helpers'
import {useMeter} from '../../../helpers/components/MeterProvider'
import UseRoutesPermission from '../../../hooks/UseRoutesPermission'

const WalletButton = () => {
  const {meter} = useMeter()
  const navigate = useNavigate()
  const {pathname} = useLocation()
  const {routes} = UseRoutesPermission()
  const isWalletActive = pathname === ROUTES.DEPOSITS.BASE

  return (
    <button
      type='button'
      className={clsx(
        'btn d-flex align-items-center flex-column justify-content-sm-between btn-sm fs-3 fw-boldest py-1 gori-wallet-btn balance-button w-100 w-xxl-auto',
        {
          'gori-wallet-btn--active balance-button--active': isWalletActive,
        }
      )}
      onClick={() => routes.DEPOSITS.hasPermission && navigate(ROUTES.DEPOSITS.BASE)}
    >
      <div className='ms-2 d-flex align-items-center'>
        <span>$</span>
        <CountUp
          start={0}
          end={meter?.balance}
          separator=','
          decimal={'.'}
          decimals={2}
          className='me-2'
        />
        <KTSVG path='/media/gori/topbar/payment-card.svg' className='svg-icon-2' />
      </div>
    </button>
  )
}

export {WalletButton}
